import React, { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import AppNavbar from "../Navbars/AppNavbar";
import { SContainer } from "../BasicComponents";
import { SBadge, SWaitingSection } from "./WaitingRoom.style";

const WaitingRoom = ({ lecture }) => {
  const { t } = useTranslation("", { keyPrefix: "components.waiting_room" });
  const startTime = moment(lecture?.startTime);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment();
      setDays(startTime.diff(now, "days"));
      setHours(startTime.diff(now, "hours") % 24);
      setMinutes(startTime.diff(now, "minutes") % 60);
      setSeconds(startTime.diff(now, "seconds") % 60);
    });

    return () => {
      clearInterval(interval);
    };
  }, [startTime]);

  return (
    <>
      {lecture && (
        <SContainer className="d-flex flex-column" fluid fill="true">
          <AppNavbar />
          <SWaitingSection>
            <h1 className="fw-bolder text-uppercase">{t("title")}</h1>
            <h1>{t("subtitle")}</h1>
            <div className="d-flex flex-row">
              <div className="d-flex flex-column justify-content-center mx-1">
                <SBadge>
                  <h1>{days}</h1>
                </SBadge>
                <h4>{t("days")}</h4>
              </div>
              <div className="d-flex flex-column justify-content-center mx-1">
                <SBadge>
                  <h1>{hours}</h1>
                </SBadge>
                <h4>{t("hours")}</h4>
              </div>
              <div className="d-flex flex-column justify-content-center mx-1">
                <SBadge>
                  <h1>{minutes}</h1>
                </SBadge>
                <h4>{t("minutes")}</h4>
              </div>
              <div className="d-flex flex-column justify-content-center mx-1">
                <SBadge>
                  <h1>{seconds}</h1>
                </SBadge>
                <h4>{t("seconds")}</h4>
              </div>
            </div>
          </SWaitingSection>
        </SContainer>
      )}
    </>
  );
};

export default WaitingRoom;
